import clsx from 'clsx';
import styles from './styles.module.scss';

export const SkeletonLine = ({
  className,
  small = false,
}: {
  className?: string;
  small?: boolean;
}) => (
  <div
    data-testid="skeleton-line"
    className={clsx(
      styles['spo-skeleton-line'],
      styles['spo-pulse'],
      small && styles['spo-skeleton-small-line'],
      className,
    )}
  />
);

export const SkeletonBloc = () => (
  <div
    data-testid="skeleton-bloc"
    className={clsx(styles['spo-skeleton-bloc'], styles['spo-pulse'])}
  />
);

export const SkeletonTable = () => (
  <div className={clsx(styles['spo-skeleton-table'])}>
    <SkeletonBloc />
    <SkeletonLine />
    <SkeletonLine />
    <SkeletonLine />
  </div>
);

export const Skeleton = () => (
  <div data-testid="skeleton" className={styles['spo-skeleton']}>
    <div
      className={clsx(styles['spo-skeleton-high-level'], styles['spo-pulse'])}
    />
    <SkeletonTable />
    <SkeletonTable />
  </div>
);
